import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { db, FirebaseTimestamp } from "../firebase/index";
import { doc, getDoc } from "firebase/firestore";
import { makeStyles } from "@material-ui/core";
import { returnCodeToBr } from "../functions/common";
import { ImageSwiper, SizeTable } from "../components/products/";
import {
  addProductToCart,
  addProductToFavorite,
} from "../reducks/users/operations";
import { getMakers } from "../reducks/makers/selectors";
import { getShops } from "../reducks/shops/selectors";
import { getCategories } from "../reducks/categories/selectors";
import { DEDUCTION, NONE_DEDUCTION } from "../constants/deduction";

const useStyle = makeStyles((theme) => ({
  sliderBox: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto 24px auto",
      height: 320,
      width: 320,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      height: 400,
      width: 400,
    },
  },
  detail: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto 16px auto",
      height: "auto",
      width: 320,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      height: "auto",
      width: 400,
    },
  },
  price: {
    color: theme.palette.warning.main,
    fontSize: 36,
  },
}));

const ProductDetail = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  // const selector = useSelector((state) => state);
  // const path = selector.router.location.pathname;
  const path = useSelector((state) => state.router.location.pathname);
  const makers = useSelector(getMakers);
  const shops = useSelector(getShops);
  const categories = useSelector(getCategories);
  const [makerName, setMakerName] = useState("");

  const id = path.split("/product/")[1];
  useEffect(() => {
    const getProduct = async () => {
      const docRef = doc(db, "products", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setProduct(docSnap.data());
      } else {
        console.log("No such document!");
      }
    };

    getProduct();
  }, []);
  useEffect(() => {
    if (makers && product) {
      const maker_name = makers
        .filter((maker) => maker.mid === product.maker)
        .map((maker) => maker.name);
      console.log("maker_name", makers, product);
      setMakerName(maker_name[0]);
    }
  }, [makers, product]);
  const addProduct = useCallback(
    (selectedItem) => {
      const timestamp = FirebaseTimestamp.now();
      const shop_name = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.name);
      const shop_fax = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.fax);
      const shop_to = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.to);
      const shop_cc = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.cc);

      const maker_name = makers
        .filter((maker) => maker.mid === product.maker)
        .map((maker) => maker.name);
      const category_name = categories
        .filter((category) => category.cid === product.category)
        .map((category) => category.name);

      // SizeTable側で書き込み完了を待てるようにthunkのPromiseを返す
      return dispatch(
        addProductToCart({
          added_at: timestamp, //追加日
          idin: product.idin, //社内番号
          idout: product.idout, //社外番号
          description: product.description, //商品詳細
          // gender: product.gender,
          images: product.images, //画像パス
          name: product.name, //商品名
          price: Number(selectedItem.basePrice), //価格
          productId: product.id, //ID
          quantity: Number(selectedItem.quantity), //数量
          size: selectedItem.size, //サイズ
          category: product.category, //カテゴリID
          category_name: category_name[0], //カテゴリ名
          maker: product.maker, //メーカーID
          maker_name: maker_name[0], //メーカー名
          shop: product.shop, //販売店ID
          shop_name: shop_name[0], //販売店名
          shop_fax: shop_fax[0], //販売店FAX
          shop_to: shop_to[0], //販売店email TO
          shop_cc: shop_cc[0], //販売店email CC
          totalPrice:
            Number(selectedItem.basePrice) * Number(selectedItem.quantity), //合計金額
          deduction_price:
            Number(selectedItem.basePrice) * Number(selectedItem.quantity), //控除金額
          deduction_id: NONE_DEDUCTION, //控除区分
          deduction_name: DEDUCTION.NONE_DEDUCTION, //控除名
          deduction_is_valid: true,
          deduction_correct_count: Number(selectedItem.quantity), //控除区分が適用できる数量
          embroidery: product.embroidery, //刺繍
          remarks: "", //備考
          ordernumber: -1,
        })
      );
    },
    [product]
  ); //productが更新されたら関数も再生成される

  const addFavorite = useCallback(
    (selectedItem) => {
      const timestamp = FirebaseTimestamp.now();
      const shop_name = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.name);
      const shop_fax = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.fax);
      const maker_name = makers
        .filter((maker) => maker.mid === product.maker)
        .map((maker) => maker.name);
      const category_name = categories
        .filter((category) => category.cid === product.category)
        .map((category) => category.name);
      const shop_to = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.to);
      const shop_cc = shops
        .filter((shop) => shop.sid === product.shop)
        .map((shop) => shop.cc);

      dispatch(
        addProductToFavorite({
          added_at: timestamp, //追加日
          idin: product.idin, //社内番号
          idout: product.idout, //社外番号
          description: product.description, //商品詳細
          // gender: product.gender,
          images: product.images, //画像パス
          name: product.name, //商品名
          price: Number(selectedItem.basePrice), //価格
          productId: product.id, //ID
          quantity: Number(selectedItem.quantity), //数量
          size: selectedItem.size, //サイズ
          category: product.category, //カテゴリID
          category_name: category_name[0], //カテゴリ名
          maker: product.maker, //メーカーID
          maker_name: maker_name[0], //メーカー名
          shop: product.shop, //販売店ID
          shop_name: shop_name[0], //販売店名
          shop_fax: shop_fax[0], //販売店FAX
          shop_to: shop_to[0], //販売店email TO
          shop_cc: shop_cc[0], //販売店email CC
          totalPrice:
            Number(selectedItem.basePrice) * Number(selectedItem.quantity), //合計金額
          deduction_price:
            Number(selectedItem.basePrice) * Number(selectedItem.quantity), //控除金額
          deduction_id: NONE_DEDUCTION, //控除区分
          deduction_name: DEDUCTION.NONE_DEDUCTION, //控除名
          deduction_is_valid: true,
          deduction_correct_count: Number(selectedItem.quantity), //控除区分が適用できる数量
          embroidery: product.embroidery, //刺繍
          remarks: "", //備考
          ordernumber: -1,
        })
      );
    },
    [product]
  ); //productが更新されたら関数も再生成される

  return (
    <section className="c-section-wrapin">
      {product && (
        <div className="p-grid__row">
          <div className={classes.sliderBox}>
            <ImageSwiper images={product.images} />
          </div>
          <div className={classes.detail}>
            <h2 className="u-text__headline__small">社内品番 {product.idin}</h2>
            <h2 className="u-text__headline">{product.name}</h2>
            <h2 className="u-text__medium__headline">{makerName}</h2>
            <p className={classes.price}>{product.price}</p>
            {/* <p className={classes.price}>￥{product.price.toLocaleString()}</p> */}
            <div className="module-spacer--small" />
            <p>{returnCodeToBr(product.description)}</p>
            <div className="module-spacer--small" />
            <SizeTable
              addProduct={addProduct}
              addFavorite={addFavorite}
              sizes={product.sizes}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductDetail;
